<div class="creatcustom">
  <div>
    <section class="customerinfo user">
      <div class="customerheader">
        <ssg-button
          [label]="'ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.NewCustomer' | translate"
          (click)="customerOrder.stateChange()"
          class="newcustomer"
          icon="icon-person_add-F"></ssg-button>
      </div>
      <hr />
      <div class="infohead justify-content-between">
        <div class="d-flex">
          <i class="icon-person_outline-F iconsize"></i>
          <h4>{{ customerOrder.currentCustomer?.DisplayName }}</h4>
        </div>
        <div class="customercode">{{ customerOrder.currentCustomer?.Number }}</div>
      </div>
      <div class="credit">
        <span>{{ "ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.LimitCredit" | translate }}</span>
        <span class="spnLeft">{{ customerOrder.currentCustomer?.CreditLimit | number }}</span>
      </div>
      <div class="credit">
        <span>{{ customerOrder.debitTitle | translate }} </span>
        <span class="spnLeft">{{ customerOrder.currentCustomer?.DebitRate | number }}</span>
      </div>
      <div class="credit">
        <span>{{ "ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.TimeArrive" | translate }} </span>
        <span *ngIf="customerOrder?.currentCustomer?.MinutesToDelivery > 0" class="spnLeft"
          >{{ customerOrder?.currentCustomer?.MinutesToDelivery }}
          {{ "ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.Minutes" | translate }}</span
        >
      </div>
      <hr />
      <div class="infohead">
        <i class="icon-local_mall-o iconsize"></i>
        <h4>{{ "ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.PurchaseInformation" | translate }}</h4>
      </div>
      <div class="buy">
        <span>{{ "ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.LastPurchase" | translate }} </span>
        <span class="spnLeft">{{ customerOrder.currentCustomer?.LastBuy | number }}</span>
      </div>
      <div class="buy">
        <span>{{ "ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.TimeOfLastPurchase" | translate }}</span>
        <span class="spnLeft">{{ customerOrder.currentCustomer?.LastBuyDate }}</span>
      </div>

      <div class="buy">
        <span> {{ "ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.PurchaseCount" | translate }}</span>
        <span class="spnLeft">{{ customerOrder.currentCustomer?.CountBuy | number }}</span>
      </div>
      <div class="buy">
        <span> {{ "ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.MostPurchases" | translate }} </span>
        <span class="spnLeft">{{ customerOrder.currentCustomer?.MaximumBuy | number }}</span>
      </div>
      <div class="buy">
        <span> {{ "ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.LeastPurchase" | translate }}</span>
        <span class="spnLeft">{{ customerOrder.currentCustomer?.MinimumBuy | number }}</span>
      </div>
      <div class="buy">
        <span> {{ "ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.SumPurchase" | translate }} </span>
        <span class="spnLeft">{{ customerOrder.currentCustomer?.TotalBuy | number }}</span>
      </div>
      <hr />
      <div class="infohead">
        <i class="icon-location_on-o iconsize"></i>
        <h4>{{ "ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.Address" | translate }}</h4>
      </div>
      <div class="customeradd">
        <div *ngFor="let address of customerOrder.currentCustomer?.Addresses" class="customeraddress">
          <input
            type="radio"
            name="address"
            [checked]="address.Id === this.customerOrder.currentCustomer.SelectedAddressId"
            (click)="ShowMinutesToDelivery($event, address)" />
          <span class="pr-2">{{ address.Address }}</span>
        </div>
      </div>
      <div class="rowbox">
        <div (click)="this.ShowAddressDialog(this.customerOrder.currentCustomer)" class="infohead">
          <ssg-button
            [disabled]="!customerOrder.currentCustomer?.Addresses"
            [label]="'ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.New' | translate"
            icon="icon-add-o"
            class="user plussize"></ssg-button>
        </div>
        <div (click)="ShowAddressEditDialog(this.customerOrder.currentCustomer)" class="infohead">
          <ssg-button
            [disabled]="!customerOrder.currentCustomer?.Addresses"
            [label]="'ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.Edit' | translate"
            icon="icon-edit-o"
            class="user plussize"></ssg-button>
        </div>
      </div>
      <hr />
      <div class="infohead">
        <i class="icon-call-o iconsize"></i>
        <h4>{{ "ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.PhoneNumbers" | translate }}</h4>
      </div>
      <div class="customeradd">
        <div *ngFor="let phone of customerOrder.currentCustomer?.Numbers" class="customeraddress">
          <input
            type="radio"
            name="phone"
            [checked]="phone.Id === this.customerOrder.currentCustomer.SelectedPhoneId"
            (click)="SetSelectedPhoneId(phone)" />
          <span class="pr-2">{{ phone.Number }}</span>
        </div>
      </div>
      <div class="rowbox">
        <div (click)="this.ShowPhoneDialog(this.customerOrder.currentCustomer)" class="infohead">
          <ssg-button
            [disabled]="!customerOrder.currentCustomer?.Numbers"
            [label]="'ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.New' | translate"
            icon="icon-add-o"
            class="user plussize"></ssg-button>
        </div>
        <div (click)="ShowEditPhoneDialog(this.customerOrder.currentCustomer)" class="infohead">
          <ssg-button
            [disabled]="!customerOrder.currentCustomer?.Numbers"
            [label]="'ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.Edit' | translate"
            icon="icon-edit-o"
            class="user plussize"></ssg-button>
        </div>
      </div>
    </section>
  </div>
  <div class="recordbtn">
    <ssg-button
      (click)="customerOrder.setCostomerInfo()"
      [label]="'ClientApp.FrontOffice.Order.CustomerOrder.CustomerDetailsOrder.Save' | translate"></ssg-button>
  </div>
</div>
